<!-- Outcome of the reset: password changed, or the link is unusable. The copy
     comes from PasswordResetState (already translated). -->
<main class="onb onb--sheet">

  <header class="onb__head">
    <p class="belturo-eyebrow onb__head-eyebrow"><%= _lcs( 'Konto' ) %></p>
    <h1 class="onb__head-title"><em><%= title %></em></h1>
    <p class="onb__head-sub"><%= sub %></p>
  </header>

  <div class="onb__scroll onb__done">
    <span class="onb-done__icon"><i class="icon icon--<%= icon %>"></i></span>
    <p class="onb-done__lead"><%= lead %></p>
  </div>

  <footer class="onb__foot onb__foot--bordered onb__foot--form">
    <button class="btn btn--primary btn--lg btn--block" type="button" data-id="to-login"><%= _lcs( 'Zur Anmeldung' ) %></button>
    <% if ( retry ) { %>
    <button class="btn btn--secondary btn--lg btn--block" type="button" data-id="retry"><%= _lcs( 'Neuen Link anfordern' ) %></button>
    <% } %>
  </footer>

</main>
